export default {"src":"/_next/static/media/SiteManagementIcon.bc8f9b32.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};